export default "__VITE_ASSET__igp6a4y___"